export const getQuantitySuggestionHintKey = (rowCount: number, isPalletSuggestion: boolean): string => {
   if (rowCount === 1) {
      return 'dynamic-product-block.small-lot.quantity-single-suggestion-hint';
   }

   if (rowCount === 2 && isPalletSuggestion) {
      return 'dynamic-product-block.small-lot.quantity-pallet-multiple-suggestions-hint';
   }

   return 'dynamic-product-block.small-lot.quantity-multiple-suggestions-hint';
};
